// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Numeral = require("../../../utils/Numeral.bs.js");
let NumberUtils = require("../NumberUtils.bs.js");
let Stdlib_List = require("@rescript/runtime/lib/js/Stdlib_List.js");
let LotSizeUtils = require("./LotSizeUtils.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let PropertyAttributes = require("../../cap/Property/components/PropertyAttributes.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let SingleFamilyPropertyAttributes_singleFamilyProperty_graphql = require("../../../__generated__/SingleFamilyPropertyAttributes_singleFamilyProperty_graphql.bs.js");

let convertFragment = SingleFamilyPropertyAttributes_singleFamilyProperty_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, SingleFamilyPropertyAttributes_singleFamilyProperty_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(SingleFamilyPropertyAttributes_singleFamilyProperty_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, SingleFamilyPropertyAttributes_singleFamilyProperty_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(SingleFamilyPropertyAttributes_singleFamilyProperty_graphql.node, convertFragment, fRef);
}

let PropertyTypeFragment_lotSizeUnit_decode = SingleFamilyPropertyAttributes_singleFamilyProperty_graphql.Utils.lotSizeUnit_decode;

let PropertyTypeFragment_lotSizeUnit_fromString = SingleFamilyPropertyAttributes_singleFamilyProperty_graphql.Utils.lotSizeUnit_fromString;

let PropertyTypeFragment = {
  lotSizeUnit_decode: PropertyTypeFragment_lotSizeUnit_decode,
  lotSizeUnit_fromString: PropertyTypeFragment_lotSizeUnit_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function SingleFamilyPropertyAttributes(props) {
  let __displayPropertyType = props.displayPropertyType;
  let displayPropertyType = __displayPropertyType !== undefined ? __displayPropertyType : true;
  let match = RescriptRelay_Fragment.useFragment(SingleFamilyPropertyAttributes_singleFamilyProperty_graphql.node, convertFragment, props.propertyType);
  let lotSizeV2 = match.lotSizeV2;
  let halfBaths = match.halfBaths;
  let beds = match.beds;
  let baths = match.baths;
  let attributes = Stdlib_List.filterMap({
    hd: [
      beds.toString(),
      beds === 1 ? "Bed" : "Beds"
    ],
    tl: {
      hd: [
        NumberUtils.formatFloat(baths),
        (baths | 0) === 1 ? "Bath" : "Baths"
      ],
      tl: {
        hd: [
          Stdlib_Option.map(halfBaths, v => v.toString()),
          Stdlib_Option.map(halfBaths, hb => {
            if (hb === 1) {
              return "HalfBath";
            } else {
              return "HalfBaths";
            }
          })
        ],
        tl: {
          hd: [
            Stdlib_Option.map(match.livingArea, Numeral.formatNumber),
            "Sqft"
          ],
          tl: {
            hd: [
              Stdlib_Option.map(lotSizeV2, v => LotSizeUtils.formatValue(v.value)),
              Stdlib_Option.map(lotSizeV2, v => LotSizeUtils.suffixFromUnit(v.unit))
            ],
            tl: {
              hd: [
                displayPropertyType ? match.displayName : undefined,
                "Empty"
              ],
              tl: /* [] */0
            }
          }
        }
      }
    }
  }, param => {
    let snd = param[1];
    let fst = param[0];
    if (fst !== undefined && snd !== undefined) {
      return [
        fst,
        snd
      ];
    }
  });
  return JsxRuntime.jsx(PropertyAttributes.make, {
    propertyAttributes: attributes,
    size: props.size
  });
}

let formatFloat = NumberUtils.formatFloat;

let make = SingleFamilyPropertyAttributes;

exports.PropertyTypeFragment = PropertyTypeFragment;
exports.formatFloat = formatFloat;
exports.make = make;
/* Numeral Not a pure module */
